import React from 'react';
import { CustomIcon } from 'shared/components/CustomIcon';

import classes from './Error.module.scss';

const Internal404 = () => {
  // const {
  //   register,
  //   handleSubmit,
  //   reset,
  //   formState: { errors, isValid }
  // } = useForm({
  //   mode: 'all'
  // });

  //#TODO: remove placeholder request
  // const submitForm = async formData => {
  //   const res = await fetch('https://jsonplaceholder.typicode.com/posts', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(formData)
  //   });

  //   if (!res.ok) {
  //     throw new Error(`Failed to send request: ${res.statusText}`);
  //   }
  // };

  // const { handleSubmitForm } = useSendFormWithNotification(submitForm, reset, {
  //   pendingMessageText: 'Sending your request...',
  //   successMessageText: 'Success! Your message has been sent.',
  //   errorMessageText: 'Something went wrong, please try again later'
  // });

  // const onSubmit = formData => {
  //   handleSubmitForm(formData);
  //   console.log(formData);
  // };

  return (
    <div className={classes.container}>
      <CustomIcon size={120} icon="clockCountdown" />
      <h4 className={classes.headerText}>
        At DuckEnergy, we continuously strive to enhance our Admin and Customer
        Dashboards.
        <br />
        This page is currently under development and will be accessible shortly.
      </h4>

      {/* <Form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <FormGroupInput
          label="Email"
          id="email"
          type="email"
          placeholder="Email"
          register={register('email', { required: 'Email is required' })}
          error={errors.email}
        />

        <Button
          type="submit"
          disabled={!isValid}
          className={classNames('orange-button', classes.button)}
        >
          Get in touch
        </Button>
      </Form> */}
    </div>
  );
};

export default Internal404;
